import closeCircle from "@micro-screens/assets/icons/instructions/close-circle.svg";
import danger from "@micro-screens/assets/icons/instructions/danger.svg";
import tickCircle from "@micro-screens/assets/icons/instructions/tick-circle.svg";
import winner from "@micro-screens/assets/icons/instructions/winner.svg";

import type { InstructionIconKey } from "@micro-screens/src/types/instruction-content";

/**
 * Bundled icon tiles for the instruction moves.
 *
 * These live under `micro-screens/assets` rather than `public/` so the folder
 * stays self-contained: copying `micro-screens` into another game brings the
 * icons with it, and the bundler fingerprints them like every other asset.
 */
export const INSTRUCTION_ICONS: Record<InstructionIconKey, string> = {
  tickCircle,
  closeCircle,
  winner,
  danger,
};
